import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AppDictionaryService } from '@services';
import { loadDictionary, loadDictionarySuccess } from './dictionary.actions';
import { ApiResponse } from '@shared';

@Injectable()
export class DictionaryEffects {
  constructor(
    private actions$: Actions,
    private appDictionaryService: AppDictionaryService,
    private toast: ToastrService,
  ) {}
  loadDictionary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDictionary),
      mergeMap(() =>
        this.appDictionaryService.getAllAppDictionary({ pageLimit: 'all', pageNum: 1 }).pipe(
          map((response: ApiResponse) => {
            return loadDictionarySuccess({ dictionary: response.data });
          }),
          catchError((error: any) => {
            // AppDictionaryService bypasses the interceptors (HttpBackend), so its errors arrive raw:
            // a 401 is the ended session the interceptor already reports once; anything else is shown as
            // text, never as "[object Object]"
            if (error?.status !== 401) this.toast.error(error?.error?.message || error?.message || 'Error');
            return of({ type: '[Dictionary] Load Dictionary Failed' });
          }),
        ),
      ),
    ),
  );
}
